import axios from 'axios'
import {HOST_API} from "../../AppConfig";

export const addZgloszenie = (dane: any) => {
    return axios({
        method: 'POST',
        url: HOST_API + `api/sygnal`,
        data: dane
    })
}
